const initStore = (store) => {
  let baseHref = ''
  if (window) {
    let baseTag = window.document.getElementsByTagName('base')[0]
    if (baseTag) baseHref = baseTag.href
  }

  const state     = {
    name : '',
    host : '',
    baseHref,
  }

  const getters   = {}
  const mutations = {
    setName (state, name) {
      state.name = name
    },
    setHost (state, name) {
      state.name = name
    },
    setSiteData (state, data) {
      for (let p in data) {
        if (data.hasOwnProperty(p)) {
          state[p] = data[p]
        }
      }
    },
  }
  const actions   = {}

  store.registerModule('Site', {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
  })
}

export default initStore
